var map = {
	"./BioMatrix.vue": 92555,
	"./DailyInvite.vue": 88032,
	"./activity.vue": 73756,
	"./airdrop-bak.vue": 39345,
	"./airdrop.vue": 45747,
	"./airdropReward.vue": 1790,
	"./bitgetWallet.vue": 55724,
	"./bitgetWalletAirdrop.vue": 23310,
	"./boost.vue": 17685,
	"./code.vue": 92354,
	"./earn.vue": 7393,
	"./frens.vue": 23234,
	"./index.vue": 2882,
	"./join.vue": 78746,
	"./lottery.vue": 18733,
	"./lotteryDetail.vue": 43047,
	"./lucky.vue": 40285,
	"./mine.vue": 42318,
	"./okxWallet.vue": 84128,
	"./pph.vue": 84051,
	"./rank.vue": 45489,
	"./sign.vue": 21328,
	"./squad.vue": 56554,
	"./taskDetail.vue": 51095,
	"./wallet.vue": 62728,
	"./withdraw.vue": 70242,
	"./youtube.vue": 93746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;